export const appMasterApi = {
    southWalesJobDescription: "v1/api/options/getById/17518732902576",
    dundeeSubjectList: "v1/api/options/getById/17524721662142",
    pdfData: "v1/api/applicationUploadDoc/pdfFileText",
    dundeeGrade:"v1/api/options/getById/17489501095013",
    huddersfieldLondonState:"v1/api/options/getById/17499243001708",
    liverpool_HS_Board: "v1/api/options/getById/17431624771859",
    lawCourseCategory: "v1/api/options/getById/17431420514115",
    eaSubject:"v1/api/options/getById/17466831949237",
    aruGrade:"v1/api/options/getById/17376096374299",
    kingstonUniversityCourses:"v1/api/options/getById/17424499387686",
    kingstonUniversityGrade:"v1/api/options/getById/17425506717214",
    ucbQualificationType:"v1/api/options/getById/17503091162481",
    greenwichStateCountry:"v1/api/options/getById/17424624741482",
    ulsterOccupation:"v1/api/options/getById/17425547785270",
    getApplication: 'v1/api/application/admin',
    getApplicationv2: 'v2/api/application/admin',
    getApplicationv3: 'v3/api/application/admin/',
    getApplicationrm: 'v1/api/application/admin/restrictedUsers/rm',
    getApplicationmarketingManager:'v1/api/application/admin/restrictedUsers/marketingManager',
    getApplicationURManager:'v1/api/application/admin/restrictedUsers/urm',
    getApplicationRManager:'v1/api/application/admin/restrictedUsers/rm',
    createApplication: 'v1/api/application',
    getNewMarksheet: 'v1/english/',
    postEnglishDetails:'v1/api/automationActivityLog',
    postUELPrescreening: 'v1/uel-pre-screening/add-to-queue',
    updateApplication: 'v1/api/application?applicationId=',
    deleteApplication: 'v1/api/application?id=',
    getAppById: 'v1/api/application/getByIdAdmin/',
    getUploadDoc: 'v1/api/applicationUploadDoc/admin?applicationId=',
    createUploadDoc: 'v1/api/applicationUploadDoc/admin',
    updateUploadDoc: 'v1/api/applicationUploadDoc',
    toggleUpdateUploadDoc: 'v1/api/applicationUploadDoc/updateFileDetails',
    deleteUploadDoc: 'v1/api/applicationUploadDoc',
    agentInfo: 'v1/api/application/admin',
    primaryStatus: 'v1/api/applicationStatus/primaryStatus',
    primaryStatusupdate: 'v1/api/applicationStatus/primaryStatus/update',
    secondaryStatus: 'v1/api/applicationStatus/secondaryStatus?primaryStatusId=',
    getApplicationHistory: 'v1/api/applicationHistory',
    getApplicationHistoryComments: 'v1/api/applicationComments/admin/',
    createApplicationHistory: 'v1/api/applicationHistory',
    createApplicationComment: 'v1/api/applicationComments/admin',
    createApplicationCommentV2: 'v1/api/userMailMaster/incoming-email/sendAgentMailByAdmin',
    updateApplicationHistory: 'v1/api/applicationHistory?applicationHistoryId=',
    deleteApplicationHistory: 'v1/api/applicationHistory?applicationHistoryId=',
    getPAQ: 'v1/api/PAQ',
    createPAQ: 'v1/api/PAQ',
    updatePAQ: 'v1/api/PAQ?PAQId=',
    deletePAQ: 'v1/api/PAQ?id=',
    getPAQbyId: 'v1/api/PAQ?applicationId=',
    getAutoUpdateStatus: 'v1/api/applicationStatus/autoUpdateStatus',
    getBETemaComm: 'v1/api/applicationStatus/internalStatus',
    getBETemaCommAgent: 'v1/api/applicationStatus/agentCommunicationStatus',
    updateCourseEnrollment: 'v1/api/coursesEnrolement?coursesEnrolementId=',
    duplicatePassport: 'v1/api/application/duplicatePassport?masterId=',
    duplicatePhoneNumber: 'v1/api/application/duplicatePhoneNumber?applicationId=',
    duplicatePassportCount: 'v1/api/application/duplicatePassportCount?masterId=',
    duplicatePhoneNumberCount: 'v1/api/application/duplicatePhoneNumberCount?applicationId=',
    duplicatePassportCountv2: 'v2/api/application/duplicatePassportCount?masterId=',
    getMarksheet: 'v1/api/marksheetVerification?',
    previousQualification: 'v1/api/studentPreviousQualification',
    extractStudentData: 'v1/api/application/export/',
    adminExport: 'v1/api/applicationUploadDoc/adminExport?applicationId=',
    copyPassport: 'v1/api/application/duplicatePassport?masterId=',
    globalSearch: 'v1/api/application/globalSearch',
    studentDataByID: "v1/api/application/getAutomationDataById/",
    submitAutomation: "v1/api/applicationAutomation",
    getretellAi: "v1/api/retellAi/automation?",
    automationStatus: "v1/api/applicationAutomation/updateLogStatus",
    getAutomationApplication: "v1/api/applicationAutomation/All",
    getAutomationActivity:'v1/api/automationActivityLog/activitylog',
    phpGetApplicationFiles: "order_application_file.php",
    phpGetApplicationComments: "order_application_comment.php",
    phpGetApplicationMails: "migration_university_communication.php",
    phpGetApplicationOrder: "order_application.php",
    phpGetApplicationOrdeStatus: "order_application_urgent.php",
    phpGetCommission: "agent/agent_commission_structure.php",
    getreAssignUser: "v1/api/applicationProcess/getreassignuser",
    getARUSubjects: "v1/api/options/getByName/ARUSubject",
    getARUQualification: "v1/api/options/getById/17374346914307",
    getBCUQualification: "v1/api/options/getById/17376089667126",
    getBCUSubject:"v1/api/options/getById/17375361394486",
    instantApply: 'v1/api/application/instantApply',
    instantApplyAdmin: 'v1/api/application/instantApply/admin',
    getUploadDocuments:'v1/api/applicationUploadDoc?applicationId=',
    getTrackerData: 'v1/api/application/exportNewGatwayExcel',
    offerConditionpost:'v1/api/applicationOfferCondition',
    getTcdAgentform:'Agent_nomination_form/agent_authorisation_form_tcd.php?orderid=',
    automationLogExport:"v1/api/applicationAutomation/export?",
    initiateCall: 'v1/api/application/retellAi/initiateCall',
    botToggle : 'v1/api/application/retellAi/updateBotCall',
    compressFile: 'v1/api/applicationUploadDoc/compressFile?applicationId=:appID&id=:docID',
    getCabin: `api_mongo/cabins.php`,
    getSeatByCabinId: `api_mongo/seats.php?cabin_id=`,
    downloadFileUpload:'v1/api/applicationUploadDoc/uploadDocInternally?id=',
    getArchiveApplication: 'v1/api/archiveApplication',
    getactivitylog: '/v1/api/automationActivityLog',
    UELgetactivitylog: 'v1/api/automationActivityLog/activitylog?camsId=',
    getAppQuestions:'v1/api/postAppQuestions/getByApplicationId?applicationId=',
    getByIdAdminMaskInfo:'v1/api/application/getByIdAdminMaskInfo',
    unMaskDetails:'v1/api/application/getByIdAdminMaskFeilds',
    getByIdAdminUnMaskInfo:'v1/api/application/getByIdAdminMaskFeilds',
    preSessionalApply: 'v1/api/application/preSessionalApply/admin',   
    liverpoolApplicationType: 'v1/api/options/getById/17509270555213',
    saveApprovalStatus: 'v1/api/application/applicationCriteriaComment?id=',
    heriotwattApplicationType : 'v1/api/options/getById/17514381538735',
    updateImportant: 'v1/api/application/updateImportant',
    getTwofactor:'v1/api/auth/2fa/verify/profile?code='
}

export const MappingTabs = {
    agent: 'Agent',
    overview: 'Overview',
    student: 'Student',
    academic: 'Academic',
    course: 'Course',
    uploads: 'Documents',
    applicationHistory: 'Application History',
    sendMail: 'Send Mail',
    universityCommunication: 'University Communication',
    callRecording: 'Call Recording',
    paq: 'PAQ',
    other: 'Others',
    // casSheet: 'Cas Sheet',
    // casAcademic: 'Cas Academic',
    // nonAcademic: 'Non Academic',
    // finance: 'Finance'
}

export const MultipleInfoTab = [
    'University Details',
    'Payment Details',
    'COA',
    'AOA',
    'Addmission UG',
    'Addmission PG',
    'Post Application',
    'Refund Process',
    'Application Process'
]

export const MappingMultipleInfoTab = {
    universityDetails: 'University Details',
    paymentDetails: 'Payment Details',
    coa: 'COA',
    aoa: 'AOA',
    addmissionUG: 'Addmission UG',
    addmissionPG: 'Addmission PG',
    postApplication: 'Post Application',
    refundProcess: 'Refund Process',
    applicationProcess: 'Application Process'
}

export const ChatGPTUrl = 'https://chat.openai.com/';
export const PlagiarismUrl = 'https://smallseotools.com/plagiarism-checker/';
export const InfoPDFUrl = 'https://www.crizac.co.uk/system/university_presentation/658e4c58f1fec_85_University%20of%20Worcester_Anita.pdf';

// dont change the content or format of disclaimer below
export const Disclaimer = 'Please note that the bank details here are true to the best of our knowledge. It is your responsibility to verify the details from university website or university. Company will not take any liability in case there is any error in the bank details provided.'

// don't change format SOP content below
export const SOPCOntent = ` 
    Please write a detailed Statement of purpose from the student's point of view for admission considering the educational background and other personal details with the proper headings and 3 points of all the reasons

    Include reasons:

    Introduction (Within 100 Words)
    Educational Background (Within 100 Words)
    Why the UK for higher studies (Within 250 Words with a long - 100 Words intro and 3 points)
    Why Not Pakistan for higher studies (Within 250 Words with a long - 100 Words intro and 3 points)
    Why De Montfort University (Within 250 Words with a long - 100 Words intro and 3 points)
    Why International Business Management MSc (Within 250 Words with a long - 100 Words intro and 3 points based on previous study)
    Future Opportunities (Within 250 Words)


    Key inputs
 
`

export const CallsType = {
    u_entension: 's_entension',
    u_mobile: 's_mobile',
    s_entension: 's_entension',
    s_mobile: 's_mobile',
    mobile: 'mobile',
    international: 'international',
    ladnline: 'ladnline',
    mannual_call: 'mannual_call',
}

export const DegreeType = {
    tenth: '1',
    twelve: '2',
    ug: '3',
    pg: '4',
    others: '5',
    othersV2: '6'
}

export const Academic_Type = {
    tenth: '10',
    twelve: '12',
    degree: 'degree',
    english: 'engliish'
}

export const applicationStopUpdate = ['64', '121', '96', '97']